import { provideHttpClient } from '@angular/common/http';
import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { HashLocationStrategy, LocationStrategy } from '@angular/common';
import { routes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [ {provide: LocationStrategy, useClass: HashLocationStrategy} , provideZoneChangeDetection({ eventCoalescing: true }), provideRouter(routes), provideHttpClient()/* ,            provideClientHydration() */
  ]
};
